namespace Nobox.Administration {
    export interface TenantRow {
        Id?: number;
        Nm?: string;
        Email?: string;
        Phone?: string;
        IsDlt?: number;
        IdtryId?: number;
        IdtryNm?: string;
        SzId?: number;
        Level?: number;
        MaxUser?: number;
        SzNm?: string;
        CtryId?: number;
        Ctry?: string;
        StatesId?: number;
        States?: string;
        CityId?: number;
        City?: string;
        ZipCode?: string;
        Note?: string;
        Address?: string;
        TenantMembers?: UserRow[];
        TenantIntegration?: IntegrationRow[];
        InvCd?: number;
        InvCdGen?: string;
        ChannelId?: number;
        Db?: number;
        ConStr?: string;
        AccountIds?: string;
        AccountEmail?: number;
        In?: string;
        Up?: string;
        IsAutoResolve?: number;
        RHours?: number;
        RMinutes?: number;
        IsAutoArchive?: number;
        AHours?: number;
        AMinutes?: number;
        OfficeHours?: string;
        Sunday?: number;
        fSunday?: string;
        lSunday?: string;
        Monday?: number;
        fMonday?: string;
        lMonday?: string;
        Tuesday?: number;
        fTuesday?: string;
        lTuesday?: string;
        Wednesday?: number;
        fWednesday?: string;
        lWednesday?: string;
        Thursday?: number;
        fThursday?: string;
        lThursday?: string;
        Friday?: number;
        fFriday?: string;
        lFriday?: string;
        Saturday?: number;
        fSaturday?: string;
        lSaturday?: string;
        During?: number;
        DuringMsg?: string;
        Outside?: number;
        OutsideMsg?: string;
        Status?: StatusTenantEnum;
        KetStatus?: string;
        Server?: string;
        PipelineId?: number;
        StageId?: number;
    }

    export namespace TenantRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Nm';
        export const localTextPrefix = 'Administration.Tenant';
        export const lookupKey = 'Administration.Tenant';

        export function getLookup(): Q.Lookup<TenantRow> {
            return Q.getLookup<TenantRow>('Administration.Tenant');
        }
        export const deletePermission = 'Security';
        export const insertPermission = 'Security';
        export const readPermission = 'Security';
        export const updatePermission = 'Security';

        export declare const enum Fields {
            Id = "Id",
            Nm = "Nm",
            Email = "Email",
            Phone = "Phone",
            IsDlt = "IsDlt",
            IdtryId = "IdtryId",
            IdtryNm = "IdtryNm",
            SzId = "SzId",
            Level = "Level",
            MaxUser = "MaxUser",
            SzNm = "SzNm",
            CtryId = "CtryId",
            Ctry = "Ctry",
            StatesId = "StatesId",
            States = "States",
            CityId = "CityId",
            City = "City",
            ZipCode = "ZipCode",
            Note = "Note",
            Address = "Address",
            TenantMembers = "TenantMembers",
            TenantIntegration = "TenantIntegration",
            InvCd = "InvCd",
            InvCdGen = "InvCdGen",
            ChannelId = "ChannelId",
            Db = "Db",
            ConStr = "ConStr",
            AccountIds = "AccountIds",
            AccountEmail = "AccountEmail",
            In = "In",
            Up = "Up",
            IsAutoResolve = "IsAutoResolve",
            RHours = "RHours",
            RMinutes = "RMinutes",
            IsAutoArchive = "IsAutoArchive",
            AHours = "AHours",
            AMinutes = "AMinutes",
            OfficeHours = "OfficeHours",
            Sunday = "Sunday",
            fSunday = "fSunday",
            lSunday = "lSunday",
            Monday = "Monday",
            fMonday = "fMonday",
            lMonday = "lMonday",
            Tuesday = "Tuesday",
            fTuesday = "fTuesday",
            lTuesday = "lTuesday",
            Wednesday = "Wednesday",
            fWednesday = "fWednesday",
            lWednesday = "lWednesday",
            Thursday = "Thursday",
            fThursday = "fThursday",
            lThursday = "lThursday",
            Friday = "Friday",
            fFriday = "fFriday",
            lFriday = "lFriday",
            Saturday = "Saturday",
            fSaturday = "fSaturday",
            lSaturday = "lSaturday",
            During = "During",
            DuringMsg = "DuringMsg",
            Outside = "Outside",
            OutsideMsg = "OutsideMsg",
            Status = "Status",
            KetStatus = "KetStatus",
            Server = "Server",
            PipelineId = "PipelineId",
            StageId = "StageId"
        }
    }
}
